module.exports = __webpack_public_path__ + "img/russia.9f1143fa.svg";